module.exports = __webpack_public_path__ + "img/crz315003.78c7c978.png";